export const videos = [
  {
    id: "v1",
    title: "《星渊》超长预告：三千特效镜头背后的宇宙",
    cover: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20station%20scene%20with%20deep%20red%20nebula%20and%20dark%20tones%2C%20cinematic%20trailer%20thumbnail%2C%20dramatic%20lighting%2C%20no%20text&width=800&height=450&seq=video-sci-fi-01&orientation=landscape",
    duration: "02:48",
    type: "drama",
    tags: ["科幻", "预告", "大片"],
    date: "2026-10-14",
    views: 245300,
    description: "官方发布的超长版预告，完整呈现《星渊》的宇宙世界观与视效制作细节，跟随镜头进入从未公开的太空站内部。",
    hot: true,
  },
  {
    id: "v2",
    title: "《夜行者》收官特辑：那些被镜头记录的深夜",
    cover: "https://readdy.ai/api/search-image?query=emotional%20night%20city%20documentary%20scene%20with%20warm%20streetlights%20and%20bokeh%2C%20cinematic%20variety%20show%20thumbnail%2C%20moody%20tones%2C%20no%20text&width=800&height=450&seq=video-night-02&orientation=landscape",
    duration: "18:36",
    type: "variety",
    tags: ["综艺", "纪实", "治愈"],
    date: "2026-10-13",
    views: 189200,
    description: "十二期节目幕后合集，收录那些没能放进正片的深夜瞬间，以及被拍摄者后来的故事。",
    hot: true,
  },
  {
    id: "v3",
    title: "《第七封信》终极反转解析，你看到第几层？",
    cover: "https://readdy.ai/api/search-image?query=suspense%20film%20scene%20with%20old%20letters%20and%20warm%20lamp%20in%20dark%20room%2C%20mysterious%20atmosphere%2C%20red%20accent%20light%2C%20no%20text&width=800&height=450&seq=video-suspense-03&orientation=landscape",
    duration: "12:05",
    type: "short",
    tags: ["解析", "悬疑", "反转"],
    date: "2026-10-13",
    views: 320100,
    description: "逐帧拆解《第七封信》的叙事结构，带你重新理解那个被无数人讨论的结局。",
    hot: true,
  },
  {
    id: "v4",
    title: "《山海奇谭》第二季高燃剪辑：国漫美学巅峰",
    cover: "https://readdy.ai/api/search-image?query=oriental%20mythical%20battle%20scene%20with%20red%20and%20gold%20clouds%20and%20ancient%20mountains%2C%20stylized%20animation%20art%2C%20dynamic%20composition%2C%20no%20text&width=800&height=450&seq=video-anime-04&orientation=landscape",
    duration: "06:22",
    type: "short",
    tags: ["国漫", "剪辑", "美学"],
    date: "2026-10-12",
    views: 156700,
    description: "本季最惊艳的高燃片段合集，感受东方美学与动作设计的完美结合。",
    hot: false,
  },
  {
    id: "v5",
    title: "林屿巡演官宣现场：新歌首唱完整版",
    cover: "https://readdy.ai/api/search-image?query=pop%20concert%20stage%20with%20warm%20red%20lights%20and%20performer%20silhouette%2C%20energetic%20live%20music%20thumbnail%2C%20stage%20haze%2C%20no%20text&width=800&height=450&seq=video-concert-05&orientation=landscape",
    duration: "05:14",
    type: "variety",
    tags: ["音乐", "现场", "新歌"],
    date: "2026-10-12",
    views: 132450,
    description: "巡演发布会现场直击，林屿首次公开演唱新专辑同名主打歌《回声》。",
    hot: false,
  },
  {
    id: "v6",
    title: "《今晚开麦》改版先导：互动综艺能玩出什么花样？",
    cover: "https://readdy.ai/api/search-image?query=modern%20interactive%20tv%20studio%20with%20red%20and%20orange%20neon%20lighting%2C%20futuristic%20variety%20show%20set%2C%20wide%20shot%2C%20no%20text&width=800&height=450&seq=video-live-06&orientation=landscape",
    duration: "09:41",
    type: "variety",
    tags: ["综艺", "互动", "直播"],
    date: "2026-10-11",
    views: 98430,
    description: "改版先导片完整版，揭秘实时投票机制背后的技术与内容设计。",
    hot: false,
  },
  {
    id: "v7",
    title: "《长夜将尽》首支国际版预告，老城里的三代人",
    cover: "https://readdy.ai/api/search-image?query=old%20town%20alley%20at%20dusk%20with%20warm%20amber%20light%20and%20soft%20mist%2C%20cinematic%20art%20film%20trailer%20thumbnail%2C%20melancholic%20tones%2C%20no%20text&width=800&height=450&seq=video-drama-07&orientation=landscape",
    duration: "01:58",
    type: "drama",
    tags: ["文艺", "预告", "电影节"],
    date: "2026-10-10",
    views: 76210,
    description: "入围国际电影节主竞赛单元的唯一华语影片，首支国际版预告正式公开。",
    hot: false,
  },
  {
    id: "v8",
    title: "明星幕后一天：陈默在山区支教的日子",
    cover: "https://readdy.ai/api/search-image?query=mountain%20village%20school%20at%20sunrise%20with%20warm%20soft%20light%2C%20documentary%20behind%20the%20scenes%20thumbnail%2C%20natural%20tones%2C%20no%20text&width=800&height=450&seq=video-doc-08&orientation=landscape",
    duration: "15:27",
    type: "short",
    tags: ["幕后", "纪录片", "明星"],
    date: "2026-10-09",
    views: 64890,
    description: "跟拍演员陈默为新剧体验生活的完整一天，记录镜头之外的真实状态。",
    hot: false,
  },
  {
    id: "v9",
    title: "老牌乐队重组纪录片：十二年后的第一次排练",
    cover: "https://readdy.ai/api/search-image?query=rock%20band%20rehearsal%20room%20with%20warm%20red%20lighting%20and%20guitars%2C%20documentary%20style%20thumbnail%2C%20gritty%20texture%2C%20no%20text&width=800&height=450&seq=video-band-09&orientation=landscape",
    duration: "22:13",
    type: "drama",
    tags: ["纪录片", "摇滚", "重组"],
    date: "2026-10-08",
    views: 112340,
    description: "十二年后重新走进排练室，记录这支老牌乐队重组巡演背后的真实故事。",
    hot: true,
  },
];